const noData = [null, "", undefined, "null"]

const state = {
  residentialContacts: [],
  residentialPrimaryContact: null,
  residentialPrimaryContactLoading: false
};

const getters = {
  residentialContacts (state) {
    return state.residentialContacts;
  },
  residentialPrimaryContact (state) {
    return state.residentialPrimaryContact;
  },
  residentialClient (state) {
    return state.residentialPrimaryContact;
  },
  residentialTaxExempt (state) {
    return !noData.includes(state.residentialPrimaryContact) &&
      !noData.includes(state.residentialPrimaryContact.tax_exempt) &&
      Boolean(Number(state.residentialPrimaryContact.tax_exempt))
  },
  residentialClientIsDisabled (state) {
    return !noData.includes(state.residentialPrimaryContact) &&
      state.residentialPrimaryContact.status === 'inactive'
  },
  residentialPrimaryContactLoading (state) {
    return state.residentialPrimaryContactLoading
  }
}

const actions = {
  setResidentialContacts(context, data) {
    context.commit('setResidentialContacts', data)
  },
  setResidentialPrimaryContact(context, data) {
    context.commit('setResidentialPrimaryContact', data)
  },
  residentialPrimaryContactLoading(context, data) {
    context.commit('residentialPrimaryContactLoading', data)
  }
}

const mutations = {
  setResidentialContacts(state, data) {
    state.residentialContacts = data;
  },
  setResidentialPrimaryContact(state, data) {
    state.residentialPrimaryContact = data;
  },
  residentialPrimaryContactLoading(state, data) {
    state.residentialPrimaryContactLoading = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};